import * as React from 'react';
import styled from 'styled-components/macro';

import Button from './Button';
import { colors, Reload } from '../lib';

export const INCOMPLETE_DATA = 'Unvollständige Daten';

function reloadPage(ev: React.SyntheticEvent) {
  ev.preventDefault();
  ev.stopPropagation();
  window.location.reload();
}

const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const HeadLine = styled.h3`
  font-size: 21px;
  text-align: center;
`;

const Text = styled.p`
  text-align: center;
`;

/* Shown instead of the app when the trip feed could not be loaded on init. */
export const FeedErrorBarrier: React.FC = () => (
  <>
    <HeadLine>Die Reisedaten konnten nicht geladen werden.</HeadLine>
    <Text>
      Bitte laden Sie die Seite neu. Besteht das Problem weiterhin, versuchen
      Sie es bitte später erneut.
    </Text>
    <ButtonWrap>
      <Button href={window.location.href} onClick={reloadPage}>
        Seite neu laden
      </Button>
    </ButtonWrap>
  </>
);

const InlineReload = styled.span`
  display: inline;
  margin-left: 8px;
  font-size: 14px;
  font-weight: normal;
  color: ${colors.red};
  white-space: nowrap;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    vertical-align: -1px;
  }
`;

/* Inline reload next to a trip name that is missing in the trip feed. */
export const ReloadLink: React.FC = () => (
  <InlineReload
    role="link"
    tabIndex={0}
    onClick={reloadPage}
    onKeyDown={(ev) => {
      if (ev.key === 'Enter') {
        reloadPage(ev);
      }
    }}
  >
    <Reload aria-hidden="true" />
    Seite neu laden
  </InlineReload>
);
